var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 64 27 C 51.3 27 41 37.3 41 50 C 41 62.7 51.3 73 64 73 C 76.7 73 87 62.7 87 50 C 87 37.3 76.7 27 64 27 z M 64 33 C 73.4 33 81 40.6 81 50 C 81 59.4 73.4 67 64 67 C 54.6 67 47 59.4 47 50 C 47 40.6 54.6 33 64 33 z M 64 81 C 47.6 81 32.400781 89.899609 24.300781 104.09961 C 23.500781 105.49961 24 107.39922 25.5 108.19922 C 26 108.49922 26.5 108.59961 27 108.59961 C 28 108.59961 29.099609 108.09961 29.599609 107.09961 C 36.599609 94.699609 49.8 87 64 87 C 78.2 87 91.4 94.699609 98.5 107.09961 C 99.3 108.49961 101.09961 108.99922 102.59961 108.19922 C 103.99961 107.39922 104.49922 105.59961 103.69922 104.09961 C 95.599219 89.899609 80.4 81 64 81 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7729fb5bc8eeb3e56ce50521aca85c1e.svg";
export { ForwardRef as ReactComponent };